<template>
  <v-dialog v-model="getModalGerarNfe" persistent max-width="960px">
    <v-card outlined :loading="$store.getters.getOverlay">
      <v-card-title> Gerar NF-e </v-card-title>
      <v-form class="px-5">
        <v-card-text>
          <Alert />
          <v-layout row wrap>
            <v-flex xs11 md11>
              <v-autocomplete
                :items="getContatos"
                item-text="nome"
                item-value="id"
                label="Cliente:"
                v-model="getVenda.cliente_id"
                outlined
                dense
              ></v-autocomplete>
            </v-flex>
            <!-- <v-flex xs11 md11>
              <v-autocomplete 
              @input="pesquisarContato2()"
              v-model="search" 
              :loading="$store.getters.getOverlay" 
              :items="getContatos" 
              item-text="nome" 
              item-value="id" 
              outlined 
              dense 
              label="Cliente:" 
              ></v-autocomplete>
            </v-flex> -->
            <v-flex xs1 md1>
              <v-row>
                <v-icon class="mt-2 mr-1 ml-5" @click="cadastrarContato"
                  >control_point</v-icon
                >
                <v-icon
                  class="mt-2 ml-1"
                  @click="visualizarContato(getVenda.cliente_id)"
                  >edit</v-icon
                >
              </v-row>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                :items="getTiposOperacaoNfe"
                v-model="getNfe.tipo_operacao"
                label="Operação:"
                item-text="descricao"
                item-value="id"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                v-model="getNfe.cfop"
                outlined
                dense
                label="CFOP:"
                v-mask="'#.###'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                :items="getTiposFreteNfe"
                v-model="getNfe.tipo_frete"
                label="Frete por Conta:"
                item-text="descricao"
                item-value="id"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 md12 v-if="getNfe.tipo_frete != 9">
              <v-autocomplete
                :items="getTransportadoras"
                item-text="nome"
                item-value="id"
                label="Transportadora:"
                v-model="getNfe.transportadora_id"
                outlined
                dense
                append-outer-icon="control_point"
                @click:append-outer="cadastrarContato"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md12>
              <v-textarea
                dense
                outlined
                label="Informações Complementares:"
                v-model="getNfe.informacao_complementar"
                @input="pesquisarContato2()"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>

      <v-card-actions>
        <v-btn
          color="default"
          outlined
          @click="setModalGerarNfe(false)"
          :loading="$store.getters.getOverlay"
          >Voltar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          outlined
          @click="gerar"
          :loading="$store.getters.getOverlay"
          >Gerar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ContatoService from "@/services/ContatoService";
var _ = require("lodash");
export default {
  data() {
    return {
      cliente_id: null,
      search: null,
    };
  },
  watch: {
    getModalGerarNfe: function () {
      if (this.getModalGerarNfe) {
        this.listarTransportadoras();
        this.listarClientes();
      }
    },
    getModalCadastroContato: function () {
      if (!this.getModalCadastroContato) {
        this.listarTransportadoras();
        this.listarClientes();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getModalGerarNfe",
      "getVenda",
      "getContatos",
      "getNfe",
      "getTiposOperacaoNfe",
      "getTiposFreteNfe",
      "getTransportadoras",
      "getModalCadastroContato",
    ]),
  },
  methods: {
    ...mapActions([
      "listarTransportadoras",
      "setModalGerarNfe",
      "gerarNfe",
      "cadastrarContato",
      "visualizarContato",
      "pesquisarContato",
    ]),
    listarClientes() {
      ContatoService.listar({
        query: {
          campo: "todos",
        },
      })
        .then((res) => {
          this.$store.commit("setContatos", res.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // pesquisarContato2() {
    //   console.log('teste')
    //   this.pesquisarContato({
    //       todos: true,
    //       campo: "nome",
    //       valor: this.search,
    //     });
    //   _.debounce(() => {
    //     console.log("teste debounce");

    //   }, 200);
    // },
    gerar() {
      this.getNfe.cliente_id = this.getVenda.cliente_id;
      this.getNfe.venda_id = this.getVenda.id;
      this.gerarNfe(this.getNfe);
    },
  },
  created() {
    // this.listarTransportadoras();
    // this.listarClientes();
  },
};
</script>
